import { EMPTY_LIST, EMPTY_OBJECT } from '../../../constants/common'
import {
  filterPermittedActionsWithDividers,
  parseActionsOnValidDivider,
} from '../../../utils/massActions'
import {
  REQUEST_ACTION_ARCHIVE_MASS,
  REQUEST_ACTION_ASSIGN_MASS,
  REQUEST_ACTION_DUE_DATE_MASS,
  REQUEST_ACTION_EDIT_CATEGORY_MASS,
  REQUEST_ACTION_EDIT_LABEL_MASS,
  REQUEST_ACTION_EDIT_PROVIDER_MASS,
  REQUEST_ACTION_MARK_AS_READ_MASS,
  REQUEST_ACTION_MARK_AS_UNREAD_MASS,
  REQUEST_ACTION_RESTORE_MASS,
  REQUEST_ACTION_UPDATE_STATUS_MASS,
} from '../../Request'

import {
  REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_ACTION_OPTION_LABEL_KEY,
  REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_ACTION_REMOVE_ATTACH_MASS,
  REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_NOTIFICATION_TITLE_KEY,
  REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_SUB_TAB_ORDER,
  REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_SUB_TAB_QA_NAME,
  REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_SUB_TAB_TEXT_KEY,
} from './RequestProfileTabAttachedRequests.constants'

export function checkIsRemoveAttachMassAction(action) {
  return (
    action === REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_ACTION_REMOVE_ATTACH_MASS
  )
}

export function getRequestProfileTabAttachedRequestsNotificationTitle({
  action,
  count,
  t,
}) {
  return t(
    REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_NOTIFICATION_TITLE_KEY[action],
    { count, totalCount: count }
  )
}

export function getRequestProfileTabAttachedRequestsSubTabItems({
  counters,
  t,
}) {
  return REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_SUB_TAB_ORDER.map(value => {
    const subTabCounters = counters?.[value] || EMPTY_OBJECT

    return {
      count: subTabCounters.total ?? null,
      text: t(REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_SUB_TAB_TEXT_KEY[value]),
      value,
    }
  })
}

export function getRequestProfileTabAttachedRequestsSubTabQaName(item) {
  return REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_SUB_TAB_QA_NAME[item.value]
}

export function getRequestProfileTabAttachedRequestsMassActions({
  canEditRelatedRequests,
  isArchive,
  permissions,
  t,
}) {
  const items = [
    {
      label: t(
        REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_ACTION_OPTION_LABEL_KEY.markAsRead
      ),
      permission: permissions.can_edit_unread_status && !isArchive,
      value: REQUEST_ACTION_MARK_AS_READ_MASS,
    },
    {
      label: t(
        REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_ACTION_OPTION_LABEL_KEY.markAsUnread
      ),
      permission: permissions.can_edit_unread_status && !isArchive,
      value: REQUEST_ACTION_MARK_AS_UNREAD_MASS,
    },
    {
      label: t(
        REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_ACTION_OPTION_LABEL_KEY.editResponsibleManagers
      ),
      permission: permissions.can_edit_assignee && !isArchive,
      value: REQUEST_ACTION_ASSIGN_MASS,
    },
    {
      label: t(
        REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_ACTION_OPTION_LABEL_KEY.editProviders
      ),
      permission: permissions.can_edit_contractors && !isArchive,
      value: REQUEST_ACTION_EDIT_PROVIDER_MASS,
    },
    {
      label: t(
        REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_ACTION_OPTION_LABEL_KEY.editStatus
      ),
      permission: permissions.can_edit_status && !isArchive,
      value: REQUEST_ACTION_UPDATE_STATUS_MASS,
    },
    {
      label: t(
        REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_ACTION_OPTION_LABEL_KEY.editDeadline
      ),
      permission: permissions.can_edit_due_date && !isArchive,
      value: REQUEST_ACTION_DUE_DATE_MASS,
    },
    {
      label: t(
        REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_ACTION_OPTION_LABEL_KEY.editLabels
      ),
      permission: permissions.can_edit_labels && !isArchive,
      value: REQUEST_ACTION_EDIT_LABEL_MASS,
    },
    {
      label: t(
        REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_ACTION_OPTION_LABEL_KEY.editCategory
      ),
      permission: permissions.can_edit_category && !isArchive,
      value: REQUEST_ACTION_EDIT_CATEGORY_MASS,
    },
    ...((canEditRelatedRequests && !isArchive) ||
    (permissions.can_archive && !isArchive) ||
    (permissions.can_restore && isArchive)
      ? [null]
      : EMPTY_LIST),
    {
      label: t(
        REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_ACTION_OPTION_LABEL_KEY.removeAttach
      ),
      permission: canEditRelatedRequests && !isArchive,
      value: REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_ACTION_REMOVE_ATTACH_MASS,
    },
    {
      label: t(
        REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_ACTION_OPTION_LABEL_KEY.archive
      ),
      permission: permissions.can_archive && !isArchive,
      value: REQUEST_ACTION_ARCHIVE_MASS,
    },
    {
      label: t(
        REQUEST_PROFILE_TAB_ATTACHED_REQUESTS_ACTION_OPTION_LABEL_KEY.restore
      ),
      permission: permissions.can_restore && isArchive,
      value: REQUEST_ACTION_RESTORE_MASS,
    },
  ]

  return parseActionsOnValidDivider(filterPermittedActionsWithDividers(items))
}
